import _ from 'lodash';
import {ScrollShadow} from "@heroui/react";
import {useInfiniteQuery, useQueryClient} from '@tanstack/react-query';
import repositories from '../../repositories.jsx';
import {useGlobalAudioPlayer} from 'react-use-audio-player';
import PageLoader from '../../components/PageLoader.jsx';
import {useEffect, useMemo} from 'react';
import EmptyProjects from '../../components/EmptyProjects.jsx';
import {useDebouncedCallback, useIntersection, useViewportSize,} from '@mantine/hooks';
import {useForm} from '@mantine/form';
import VoiceModelGenerate from '../../widgets/VoiceModelGenerate.jsx';
import VoiceCard from '../../widgets/VoiceCard.jsx';
import Header from '../../components/Header.jsx';

export default function MyVoices({search = null}) {
	const {load, isReady, isLoading, stop, playing, src, setVolume} = useGlobalAudioPlayer();
	const {width, height} = useViewportSize()
	const {ref, entry} = useIntersection({
		threshold: 0.2,
	});
	const queryClient = useQueryClient()
	
	const form = useForm({
		initialValues: {
			search: '',
			provider: '',
			per_page: 16,
		}
	})
	
	const voiceList = useInfiniteQuery({
		queryKey: ['voiceList'],
		queryFn: ({pageParam}) => repositories.project.voiceList(_.merge(form.values, {page: pageParam, key: "own"})),
		initialPageParam: 1,
		getNextPageParam: (lastPage, pages, lastPageParam) => lastPage?.rows?.length > 15 ? lastPageParam + 1 : null,
	})
	
	const handleSearch = useDebouncedCallback(async () => {
		//await queryClient.resetQueries(['voiceList'])
		setVolume(0.1)
		await voiceList.refetch()
		stop();
		setVolume(1)
	}, 1000);
	
	form.watch('search', () => {
		if (voiceList.isFetched) {
			handleSearch()
		}
	})
	
	form.watch('provider', () => {
		if (voiceList.isFetched) {
			handleSearch()
		}
	})
	
	const playAudio = (src) => {
		if (!_.startsWith(src, 'http')) return;
		stop();
		load(src, {
			autoplay: true
		})
	}
	
	useEffect(() => {
		setTimeout(() => {
			voiceList?.hasNextPage && voiceList.isFetched && entry?.isIntersecting && voiceList.fetchNextPage()
		}, 1000)
	}, [entry?.isIntersecting]);
	
	const allVoices = useMemo(() => {
		return _.flatMap(voiceList.data?.pages, (item) => item?.rows || []);
	}, [voiceList.data])
	
	const inputWrapper = 'min-h-12 min-w-[400px] bg-default-500/5 border-1 data-[focus=true]:!border-primary data-[hover=true]:border-primary shadow-none';
	
	return (
		<div className="relative">
			<Header currentPage="my-voices"/>
			
			<div className="flex justify-between items-center gap-3 absolutes top-0 right-10">
				{/*<h2 className="font-sans font-medium text-2xl">My Voices</h2>*/}
				<div></div>
				<div className="flex justify-between items-center gap-5">
					<VoiceModelGenerate/>
				</div>
			</div>
			<ScrollShadow
				style={{
					height: `80dvh`,
					maxHeight: `${height - 220}px`
				}}
				className="overflow-y-auto p-2 scrollbar-hide">
				
				{(voiceList?.isLoading || voiceList?.isFetching) &&
					<div className="w-full h-full top-0 left-0 fixed z-50 transition-all duration-300">
						<PageLoader/>
					</div>
					
				}
				
				{voiceList?.isSuccess && _.size(allVoices) > 0 &&
					<>
						<div className="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-4 gap-4 pb-10 ">
							{allVoices.map((item, index) => (
								<VoiceCard
									playAudio={playAudio}
									data={item} key={index}/>
							))}
						</div>
						{voiceList.hasNextPage &&
							<div ref={ref} className="w-full flex justify-center items-center py-4">
								<PageLoader size="md"/>
							</div>
						}
					</>
				}
				{voiceList?.isSuccess && _.size(allVoices) <= 0 &&
					<div className="rounded-20 bg-white p-6">
						<div
							className="text-center flex-grow h-[initial] border-dashed border-2  overflow-hidden border-slate-500/30 rounded-20 cursor-pointer flex flex-col items-center justify-center">
							<EmptyProjects
								icon={<img src="/images/no-result.jpg" alt="upload-icon"
								           className="max-w-32 mx-auto mb-5 grayscale"/>}
								title='No Voices Available'
								children='It looks like there are no voice listings yet. Start by adding a new voice to get started!'
								className="bg-white bg-[url()] w-full h-full min-h-[600px] py-32"
							/>
						</div>
					</div>
				}
			</ScrollShadow>
			
			{/*<div className="flex justify-end items-end gap-5 fixed right-10 bottom-10">*/}
			{/*	<VoiceModelGenerate/>*/}
			{/*</div>*/}
		</div>
	)
}
